/*
 * @Author: zxl
 * @Date: 2021-06-08 18:09:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-09 13:58:25
 * @Description: 描述
 * @FilePath: \XBAdmine:\qqjieshou\XBAdminVUE\src\views\Set\Filiale\api\service.js
 */

import axios from '../../../../utils/request';
function GET_FORM_LIST(params) {
    return axios.get("/information/AInformationPosition/add",{
        params: {

        }
    } )
}
function GET_LIST(params) {
    return  axios.get("/information/AInformationPosition/index",{...params} )
}

function CHANG_STATUS (params) {
    return  axios.post("/information/AInformationPosition/statusEdit",{status:params} )
}
function GET_FORM_DATA(params) {
    return  axios.get("/information/AInformationPosition/edit",{ params: {
            ...params
        }} )
}
function DELE(params) {
    return  axios.get("/information/AInformationPosition/delete",{ params: {
            ids:params
        }} )
}

function SUBMIT_ADD(params) {
    return  axios.post("/information/AInformationPosition/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/information/AInformationPosition/editPost",{...params} )
}
function CHANG_STATUS_FILALE(params) {
    return  axios.post("/team/ATeamCustomerService/statusEdit",{
        status: {
            ...params
        }
    } )
}
export default {
    GET_FORM_DATA,
    GET_FORM_LIST,
    GET_LIST,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    DELE,CHANG_STATUS
};
